module.exports = __webpack_public_path__ + "img/af2baf3b62ba9ee43180.b2ca485b.jpeg";